import Radio from 'backbone.radio';
import { Model } from 'backbone';
import RootLayout from '../../../../core/layouts/Root';
import { User } from "../../models";
import { ActivateGameView, CoachPopup, OnboardingView } from '../../views';
import { Storage, isAuthorized, hasSid } from '../../../../core/utils';

const channel = Radio.channel('coach');
const channelUserModals = Radio.channel('userModals');

export default class extends RootLayout {
	initialize() {
		this.listenTo(channel, 'show:popup', this.showCoachPopup);
		this.listenTo(channel, 'show:popup:smart', this.showCoachPopupSmart);
		this.listenTo(channelUserModals, 'show:activation:modal', this.showActivationModal);
		this.listenTo(channelUserModals, 'show:onboarding:modal', this.showOnboardingModal);
		this.listenTo(channelUserModals, 'hide:onboarding:modal', this.hideOnboardingModal);

	}


	showCoachPopupSmart() {
		let should_show_popup =  isAuthorized() && User.with_trial && (
			!Storage.get('disable_coach_notifications') &&
			!User.get('coach_trial_popup')
		);

		if (!should_show_popup) {
			return this;
		}

		if (User.is_coach_soon_expired) {
			let view = new CoachPopup({
				model: new Model(User.toJSON())
			});

			view.switchToReminderTemplate();

			this.getRegion('coach').show(view);
		}

		if (User.is_coach_trial_end) {
			let view = new CoachPopup({
				model: new Model(User.toJSON())
			});

			view.switchToTrialEndTemplate();

			this.getRegion('coach').show(view);
		}

		return this;
	}

	showCoachPopup() {
		const view = new CoachPopup({
			model: new Model()
		});

		this.getRegion('coach').show(view);

		return this;
	}

	showActivationModal() {
		if(hasSid()) {
			this.getRegion('user_modal').show(new ActivateGameView())
		}

		return this;
	}

	showOnboardingModal() {
		this.getRegion('user_modal').show(new OnboardingView({
			game_title: 'Fantasy'
		}))
	}

	hideOnboardingModal() {
		this.getRegion('user_modal').currentView.destroy();

		this.showCoachPopup();
	}
}